import {
  LOGIN_CLINIC_REQUEST,
  LOGIN_CLINIC_SUCCESS,
  LOGIN_CLINIC_FAILURE,
  LOGOUT_CLINIC,
} from './authActions';

const initialState = {
  user: null,
  clinics: [],
  loading: false,
  error: null,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_CLINIC_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGIN_CLINIC_SUCCESS:
      return {
        ...state,
        user: action.payload.data.account,
        clinics: action.payload.data.account.clinics,
        // user: action.payload.account,
        // clinics: action.payload.account.clinics,
        loading: false,
        error: null,
      };
    case LOGIN_CLINIC_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LOGOUT_CLINIC:
      return {
        ...state,
        user: null,
        clinics: [],
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default loginReducer;
